import { postToParent } from './messages.js';

const sendVote = async (url, data) => {
	const response = await fetch(url, {
		method: 'POST',
		body: data,
	});
	if (!response.ok) {
		throw new Error(`Server responded with status: ${response.status}`);
	}
	return response.text();
};

const showError = (form) => {
	const errorMessage = document.createElement('div');
	errorMessage.classList.add('error-message');
	errorMessage.innerText = 'Nie udało się oddać głosu. Proszę spróbować ponownie.';
	form.append(errorMessage);
	setTimeout(() => errorMessage.remove(), 5000);
};

const categorySelect = (form) => {
	const select = form.querySelector('.embed-select');
	if (!select) return;
	const toggle = select.querySelector('.embed-select__toggle');
	const value = select.querySelector('.embed-select__value');
	const input = form.querySelector('input[name=kategoria]');

	const setOpen = (open) => {
		select.classList.toggle('__js_open', open);
		toggle.setAttribute('aria-expanded', open);
	};

	toggle.addEventListener('click', () => setOpen(!select.classList.contains('__js_open')));

	select.querySelectorAll('.embed-select__option').forEach((option) => {
		option.addEventListener('click', () => {
			const { category } = option.dataset;
			select.querySelectorAll('.embed-select__option').forEach((el) => el.classList.remove('__js_selected'));
			option.classList.add('__js_selected');
			value.innerText = option.innerText;
			input.value = category;
			form.querySelectorAll('.candidate[data-category]').forEach((candidate) => {
				candidate.hidden = candidate.dataset.category !== category;
			});
			setOpen(false);
		});
	});

	document.addEventListener('click', (e) => {
		if (!select.contains(e.target)) setOpen(false);
	});
};

export const embedVoting = () => {
	const form = document.querySelector('.embed__voting');
	if (!form) return;
	const url = form.dataset.entryUrl;
	const buttons = form.querySelectorAll('.candidate__button');

	categorySelect(form);

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		if (!url) {
			console.log('Fatal error - no form entry url');
			return;
		}

		const button = e.submitter;
		const candidate = button?.closest('.candidate');
		if (!candidate) return;

		const data = new FormData(form, button);
		data.set('kategoria', candidate.dataset.category);
		data.append('button', 'submit');
		data.append('form_placement', 'embed');

		candidate.classList.add('__js_selected');
		buttons.forEach((btn) => { btn.disabled = true; });

		try {
			const html = await sendVote(url, data);
			const response = document.createElement('div');
			response.classList.add('embed__response');
			response.innerHTML = html;
			form.replaceWith(response);
			postToParent('scrollIntoView');
		} catch (err) {
			console.log('Error', err);
			candidate.classList.remove('__js_selected');
			buttons.forEach((btn) => { btn.disabled = false; });
			showError(form);
		}
	});
};
